import { FC } from 'react';
import { PCC_AVAILABLE_TOOLTIP_DISCLAIMER_TYPE } from 'constants/messageCode';
import LegacyAvailability from 'components/availability-wrapper/legacy-availability/legacy-availability';
import ModernAvailability from 'components/availability-wrapper/modern-availability/modern-availability';

interface CommonAvailabilityWrapperProps {
  availabilityData;
  shouldDisplayLabel: boolean;
  isLoading: boolean;
  locale: string;
  dealerData;
  dealerInformation;
  availRemoveInterimStockFlag: boolean;
  isShowSourcingDetailEnabled: boolean;
  isDeliveryEnabled: boolean;
  openInDrawer?: boolean; 
  isPccReleaseRemanReplacement?: boolean;
}

const CommonAvailabilityWrapper: FC<CommonAvailabilityWrapperProps> = ({
  availabilityData,
  shouldDisplayLabel,
  isLoading,
  locale,
  dealerData,
  dealerInformation,
  availRemoveInterimStockFlag,
  isShowSourcingDetailEnabled,
  isDeliveryEnabled,
  openInDrawer,
  isPccReleaseRemanReplacement = false
}) => {
  const { hoseAvailabilityLabel = '', hoseAssemblyIndicator } =
    availabilityData ?? {};
  const hoseAssemblyDetails = { hoseAvailabilityLabel, hoseAssemblyIndicator };
  const availabilityToolTipMessage = PCC_AVAILABLE_TOOLTIP_DISCLAIMER_TYPE;

  const {
    storeFeatures: { isStoreAvailabilityEnabled = false, isPickupEnabled },
    featureFlags: { PCC_availRemoveInterimStockFlag }
  } = dealerInformation ?? {
    storeFeatures: {},
    featureFlags: {}
  };
  const commonProps = {
    availabilityData: availabilityData?.availability,
    isPickupEnabled,
    isDeliveryEnabled,
    locale,
    isLoading,
    availabilityToolTipMessage,
    hoseAssemblyDetails,
    hideToolTipIcon: false
  };
  return isStoreAvailabilityEnabled ? (
    <ModernAvailability
      {...commonProps}
      showSourcingDetailToggle={isShowSourcingDetailEnabled}
      hideLabel={!shouldDisplayLabel}
      sourcingDetails={availabilityData?.sourcingDetails}
      address={dealerData?.address}
      isPccReleaseRemanReplacement={isPccReleaseRemanReplacement}
      openInDrawer={openInDrawer}
      availRemoveInterimStockFlag={availRemoveInterimStockFlag}
      storeAvailability={availabilityData?.storeAvailability}
      PCC_availRemoveInterimStockFlag={PCC_availRemoveInterimStockFlag}
      hideSourceAndDates={false}
      shouldWrap={true}
    />
  ) : (
    <LegacyAvailability
      {...commonProps}
      dealerData={dealerData}
      hideLabel={true}
    />
  );
};
export default CommonAvailabilityWrapper;
